/*
  防伪查询 js
*/
//创建ajax函数
function createXMLHTTP()
{
    var xmlhttp=null;
    if(window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest(); //firefox下执行此语句
    }
    else if(window.ActiveXObject){
        try{
          xmlhttp = new ActiveXObject("Msxm12.XMLHTTP");
        }catch(e){
            try{ // code for IE6, IE5
                xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
            }catch(e){}
        }
    }
	return xmlhttp;

}
//全局XMLHTTP对象实力变量
var http  = createXMLHTTP();
//发送查询的请求
function SecurityCodeGetQuery()
{
		var security_code     = document.getElementById("security_code_input").value;
		var query_status = document.getElementById("security_code_query_status").value;
		
		var search      = document.getElementById("security_code_search").value;
		var lang      = "english";
		var should_query = 1;

		
		if(security_code == ""){

            msg = "Security code can not be empty.";

			alert(msg);
			document.getElementById("security_code_input").focus();
			return false;
		}
		

		////重新赋值
		///将前一次查询的编号赋值给界面元素value
		document.getElementById("security_code_search").value = security_code;
		//document.getElementById('ButOK').disabled = true;
		//  如果当前查询防伪码和上一次查询的不一样，则执行查询动作，否则啥也不做。

		if(search != security_code){	
			//两次输入查询项不一样的，肯定要查询
			should_query = 1;
		} else if (query_status != 1) {
			//输入查询项一样，但是上一次查询状态不为 1 的，也运行查询。
			should_query = 1;
		} else {
			//除此之外，不需要查询 两次输入一样，而且前面一次已经查询成功了。
			should_query = 0;
		}
		
		if (should_query == 1) {
			//需要查询的时候才做查询，否则啥也不做
			var url="https://www.szehpro.com/server/merrymi/qr/qr.php?act=query";
			
			url+=("&security_code="+security_code);
			http.open("GET",url,true);
			http.onreadystatechange=SecurityCodeProcessHttpResponse;
			http.send(null);
			return;
		}
		
}
//处理查询的请求
function SecurityCodeProcessHttpResponse()
{
	if(http.readyState==4)
	{
		if(http.status==200)
		{
			var http_response = http.responseText;
			var arr_str=new Array();
			arr_str=http_response.split("|");

			document.getElementById("security_code_result_str").innerHTML  = arr_str[1];
			document.getElementById("security_code_query_status").value = arr_str[0];
            /////document.getElementById("tgs_lottery_result_str").innerHTML  = arr_str[2];
            

			
		}
		else
		{
			alert("error:" + http.status);
		}
	}

}

